import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

export default ClassNameGenerator;
